import {
  Box,
  Button,
  Center,
  Table,
  TableCaption,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { IoIosAddCircle } from "react-icons/io";
import Moment from "moment";
import { useNavigate } from "react-router-dom";

export const ModalPedidos = (dados) => {
  const navigate = useNavigate();

  return (
    <Center>
      <Box w="960px" mt="1rem" fontFamily="Akrobat">
        <Table variant="striped" colorScheme="blackAlpha">
          <TableCaption fontFamily="Akrobat ExtraBold">
            Tabela de Pedidos
          </TableCaption>
          <Box>
            <Thead>
              <Tr>
                <Th w="240px" color="#03a9f4">
                  Nº do Orçamento
                </Th>
                <Th w="240px" color="#03a9f4">
                  Tipo de Pedido
                </Th>
                <Th w="240px" color="#03a9f4">
                  Data
                </Th>
                <Th color="#03a9f4">Valor</Th>
              </Tr>
            </Thead>
          </Box>
          <Tbody>
            <Box w="960px" overflowY="scroll" maxH="280px">
              {dados.data.data.pedidos.map((dado) => {
                return (
                  <Tr>
                    {dado.numero_orcamento === "" ||
                    dado.numero_orcamento == null ? (
                      <Td w="240px">Sem informação</Td>
                    ) : (
                      <Td w="240px">{dado.numero_orcamento}</Td>
                    )}
                    {dado.tipo_de_orcamento === "" ||
                    dado.tipo_de_orcamento == null ? (
                      <Td w="240px">Sem informação</Td>
                    ) : (
                      <Td w="240px">{dado.tipo_de_orcamento}</Td>
                    )}
                    {dado.data_orcamento === "" ||
                    dado.data_orcamento == null ? (
                      <Td w="240px">Sem informação</Td>
                    ) : (
                      <Td w="240px">
                        {Moment(dado.data_orcamento).format("DD-MM-YYYY")}
                      </Td>
                    )}
                    {dado.valor_orcamento === "" ||
                    dado.valor_orcamento == null ? (
                      <Td>Sem informação</Td>
                    ) : (
                      <Td>
                        {parseFloat(dado.valor_orcamento).toLocaleString(
                          "pt-BR",
                          {
                            style: "currency",
                            currency: "BRL",
                          }
                        )}
                      </Td>
                    )}
                    <Td>
                      <Button
                        leftIcon={
                          <IoIosAddCircle color="#03a8f4" size="20px" />
                        }
                        variant="link"
                        boxShadow="none !important"
                        _hover={{ opacity: 0.8 }}
                        size="md"
                        color="#03a8f4"
                        onClick={() => {
                          navigate("/orcamento?p=" + dado.numero_orcamento, [
                            false,
                          ]);
                        }}
                      >
                        Detalhes
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
            </Box>
          </Tbody>
        </Table>
      </Box>
    </Center>
  );
};
